import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-jquidroppable',
	templateUrl:'./JQUIDroppablePluginCompPage.html',
	styles: [],
	styleUrls:['./JQUIDroppablePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class JQUIDroppablePluginCompPage
{
	mdContent_1018 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.droppable.JQUIDroppable;
\`\`\``;
	mdContent_1019 = `\`\`\`java
JQUIDroppable()
\`\`\``;
	mdContent_1020 = `\`\`\`java
JQUIDroppable&lt;?&gt; drop = new JQUIDroppable&lt;&gt;();
drop.setText("Drop here");
drop.getOptions().setAccept(".draggable-item");
drop.getOptions().setHoverClass("highlight");
drop.getOptions().setTolerance("pointer");
\`\`\``;
}
